import { render, staticRenderFns } from "./wordpress-illustration.vue?vue&type=template&id=25d01b58"
import script from "./wordpress-illustration.vue?vue&type=script&lang=js"
export * from "./wordpress-illustration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports